import { render, staticRenderFns } from "./TrailerDetailsCards.vue?vue&type=template&id=25b0d30e&scoped=true"
import script from "./TrailerDetailsCards.vue?vue&type=script&lang=js"
export * from "./TrailerDetailsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b0d30e",
  null
  
)

export default component.exports